module.exports = __webpack_public_path__ + "static/media/chargeable-icon.203fbf7a.svg";